function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin, Messaging } from 'oskari-ui/util';
import { showSnippetPopup } from '../view/embedded/SnippetPopup';
var MapsHandler = /*#__PURE__*/function (_StateHandler) {
  function MapsHandler(instance) {
    var _this;
    _classCallCheck(this, MapsHandler);
    _this = _callSuper(this, MapsHandler);
    _this.instance = instance;
    _this.sandbox = Oskari.getSandbox();
    _this.setState({
      data: [],
      loading: false
    });
    _this.popupControls = null;
    _this.loc = Oskari.getMsg.bind(null, 'MyData');
    _this.viewService = _this.instance.getViewService();
    _this.eventHandlers = _this.createEventHandlers();
    _this.refreshViewsList();
    return _this;
  }
  _inherits(MapsHandler, _StateHandler);
  return _createClass(MapsHandler, [{
    key: "popupCleanup",
    value: function popupCleanup() {
      if (this.popupControls) this.popupControls.close();
      this.popupControls = null;
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PublishedMapsHandler';
    }
  }, {
    key: "showHtml",
    value: function showHtml(view) {
      var _this2 = this;
      if (this.popupControls) {
        this.popupCleanup();
      }
      this.popupControls = showSnippetPopup(view, function () {
        return _this2.popupCleanup();
      });
    }
  }, {
    key: "refreshViewsList",
    value: function refreshViewsList() {
      var _this3 = this;
      this.updateState({
        loading: true
      });
      this.viewService.loadViews('PUBLISHED', function (isSuccess, response) {
        if (isSuccess) {
          _this3.updateState({
            data: response.views,
            loading: false
          });
        } else {
          Messaging.error(_this3.loc('tabs.publishedmaps.error.loadfailed'));
          _this3.updateState({
            loading: false
          });
        }
      });
    }
  }, {
    key: "getViewById",
    value: function getViewById(id) {
      for (var i = 0; i < this.state.data.length; i += 1) {
        if (this.state.data[i].id === id) {
          // found what we were looking for
          return this.state.data[i];
        }
      }
      // couldn't find view -> show an error
      Messaging.error(this.loc('tabs.publishedmaps.error.generic'));
    }
  }, {
    key: "confirmSetState",
    value: function confirmSetState(cb, blnMissing) {
      var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
      var okBtn = Oskari.clazz.create('Oskari.userinterface.component.Button');
      okBtn.setTitle(this.loc('tabs.publishedmaps.button.ok'));
      okBtn.addClass('primary');
      okBtn.setHandler(function () {
        dialog.close();
        if (cb && blnMissing) {
          cb();
        }
      });
      var cancelBtn = dialog.createCloseButton(this.loc('tabs.publishedmaps.button.cancel'));
      if (blnMissing) {
        dialog.show(this.loc('tabs.publishedmaps.popup.showErrorTitle'), this.loc('tabs.publishedmaps.popup.showConfirmMissing'), [cancelBtn, okBtn]);
      } else {
        dialog.show(this.loc('tabs.publishedmaps.popup.showErrorTitle'), this.loc('tabs.publishedmaps.popup.showConfirmNotLoaded'), [cancelBtn]);
      }
      dialog.makeModal();
    }
  }, {
    key: "deleteView",
    value: function deleteView(view) {
      var _this4 = this;
      this.updateState({
        loading: true
      });
      this.viewService.deleteView(view, function (isSuccess) {
        if (isSuccess) {
          _this4.refreshViewsList();
        } else {
          Messaging.error(_this4.loc('tabs.publishedmaps.error.notdeleted'));
          _this4.updateState({
            loading: false
          });
        }
      });
    }
  }, {
    key: "isCurrentProjectionSupportedForView",
    value: function isCurrentProjectionSupportedForView(data) {
      var currentProjection = Oskari.getSandbox().getMap().getSrsName();
      var viewProjection = data.state.mapfull.state.srs;
      return viewProjection === currentProjection;
    }
  }, {
    key: "constructUrlWithUuid",
    value: function constructUrlWithUuid(srs, editUuid, viewData) {
      var sandbox = Oskari.getSandbox();
      var uuid;
      var views = Oskari.app.getSystemDefaultViews();
      views.forEach(function (view) {
        if (view.srsName === srs) {
          uuid = view.uuid;
        }
      });
      var url = sandbox.createURL('/?uuid=' + uuid, false);
      if (viewData) {
        url += this.getMapStateParameters(viewData);
      }
      if (editUuid) {
        url += '&editPublished=' + editUuid;
      }
      return url;
    }
  }, {
    key: "getMapStateParameters",
    value: function getMapStateParameters(view) {
      var mapStateParams = '';
      if (view && view.state && view.state.mapfull && view.state.mapfull.state) {
        var state = view.state.mapfull.state;
        // Set zoom and location
        mapStateParams += '&zoomLevel=' + state.zoom + '&coord=' + state.east + '_' + state.north;
        // Set layer parameters
        if (state.selectedLayers) {
          var layerParams = '&mapLayers=';
          state.selectedLayers.forEach(function (layer) {
            if (layerParams !== '') {
              layerParams += ',';
            }
            layerParams += layer.id + '+' + layer.opacity;
            if (layer.style) {
              layerParams += '+' + layer.style;
            } else {
              layerParams += '+';
            }
          });
          mapStateParams += layerParams;
        }
      }
      return mapStateParams;
    }
  }, {
    key: "createProjectionChangeDialog",
    value: function createProjectionChangeDialog(cb) {
      var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
      var btn = dialog.createCloseButton(this.loc('projectionError').ok);
      var cancel = dialog.createCloseButton(this.loc('projectionError').cancel);
      cancel.setHandler(function () {
        dialog.close(true);
      });
      btn.addClass('primary');
      btn.setHandler(function () {
        cb();
        dialog.close(true);
      });
      dialog.show(this.loc('projectionError').title, this.loc('projectionError').msg, [cancel, btn]);
      dialog.makeModal();
    }
  }, {
    key: "editView",
    value: function editView(data) {
      var _this5 = this;
      var sandbox = Oskari.getSandbox();
      var srs = data.state.mapfull.state.srs;
      var embeddedMapUuid = data.uuid;
      var supported = this.isCurrentProjectionSupportedForView(data);
      if (!supported) {
        this.createProjectionChangeDialog(function () {
          window.location.href = _this5.constructUrlWithUuid(srs, embeddedMapUuid, data);
        });
        return;
      }
      var resp = this.viewService.isViewLayersLoaded(data, sandbox);
      if (resp.status) {
        this.editRequestSender(data);
      } else {
        this.confirmSetState(function () {
          _this5.editRequestSender(data);
        }, resp.msg === 'missing');
      }
    }
  }, {
    key: "setPublished",
    value: function setPublished(data) {
      var _this6 = this;
      this.updateState({
        loading: true
      });
      var view = this.getViewById(data.id);
      if (view) {
        var newState = !view.isPublic;
        this.viewService.makeViewPublic(data.id, newState, function (isSuccess) {
          if (isSuccess) {
            _this6.refreshViewsList();
          } else {
            Messaging.error(_this6.loc('tabs.publishedmaps.error.makePrivate'));
            _this6.updateState({
              loading: false
            });
          }
        });
      }
    }
  }, {
    key: "editRequestSender",
    value: function editRequestSender(data) {
      var sandbox = Oskari.getSandbox();
      var publishMapEditorRequestBuilder = Oskari.requestBuilder('Publisher.PublishMapEditorRequest');
      if (publishMapEditorRequestBuilder) {
        var req = publishMapEditorRequestBuilder(data);
        sandbox.request(this.instance, req);
      }
      var closeFlyoutRequestBuilder = Oskari.requestBuilder('userinterface.UpdateExtensionRequest');
      if (closeFlyoutRequestBuilder) {
        var closeFlyoutRequest = closeFlyoutRequestBuilder(this.instance, 'close', this.instance.getName());
        sandbox.request(this.instance.getName(), closeFlyoutRequest);
      }
    }
  }, {
    key: "createEventHandlers",
    value: function createEventHandlers() {
      var _this7 = this;
      var handlers = {
        'Publisher.MapPublishedEvent': function PublisherMapPublishedEvent(event) {
          _this7.refreshViewsList();
        }
      };
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return _this7.sandbox.registerForEventByName(_this7, p);
      });
      return handlers;
    }
  }, {
    key: "onEvent",
    value: function onEvent(e) {
      var handler = this.eventHandlers[e.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [e]);
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(MapsHandler, ['deleteView', 'editView', 'setPublished', 'showHtml']);
export { wrapped as PublishedMapsHandler };